// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:09:55+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            2e0182c4cf49ce7272a9e0af83ec6981
//    Signature:      eyJpdiI6Im9hTEpPaHNRbkFlTnpBeWVXNm9hWVE9PSIsInZhbHVlIjoiR1EzSERUbk9hNHY1SWJMclBYdFpaZ2hhckI4aEJVRmRSSHNmZFAzbjZSNm1pZ1NHS25SazA1K1o4bnF0d0RBcHpiSUpTQ0lXTHFOck1yZkQzU1RRVUF3RTNIdWdpTFQ0ZDFLR3dtWmNmMnFkUFhhU1RQejdiYSt6UWw3bnczV2ZDZW1ITDVuVGxYR2Z6R1BxZk5GRjg0bmZVamoxbWprTHlablhFajZUb00wMkpFVURoSVhaMDh1Z1lGajNYRU5kcDk1dmNiXC9BU0ZmaXVaVjNVRHpCeFF4aWxkamJzRUJSNkNZZTBVYUhDZXYyZ3AydWxiWjREOEs5ZVJQTVZ4dVBSRElwSTNlMnBSVjNSeDA3Z3NhU0RqTGRqUnpNalwvVElSNVwvbURTSW1aZmViVm5EVVFDYzQyXC9DZHh1bTdDSFJZM25QVTlpRllBOTB0NnRsY1lNZ2c1ZkpwaHhIU2IrT0Jmd0grR1AyaERWXC9GVUoyWGNlbHZUU2E3YmhrYjJObTh1aUsxZ0Z0ek9NWnRNQ2NDT21rOVg4TXE2cllyNk82eEJcL3JlTFpuT3hGST0iLCJtYWMiOiJhZDE3NGMxMDBiOTJiZGUzN2Q0YTgwZDFiMzJmYTE2OTEwNzAzNDhmNGJlYzUyYzgyY2E2MmVkNGIzN2I2OWVjIn0=
if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
